// extracted by mini-css-extract-plugin
export default {"Lang":"Lang_Lang__1U6iO","Lang_active":"Lang_Lang_active__3Eb-Z"};